/**
 * @license lucide-vue-next v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const SquareArrowRightExit = createLucideIcon("square-arrow-right-exit", [
  ["path", { d: "M10 12h11", key: "6m4ad9" }],
  ["path", { d: "m17 16 4-4-4-4", key: "iin4zf" }],
  [
    "path",
    {
      d: "M21 6.344V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-1.344",
      key: "1ojbhp"
    }
  ]
]);

export { SquareArrowRightExit as default };
//# sourceMappingURL=square-arrow-right-exit.js.map
